import {
  CLEAR_FETCHED_STAFF,
  SEARCH_STAFF,
  SEARCH_STAFF_FAILURE,
  SEARCH_STAFF_SUCCESS,
} from '../constants/ActionTypes';

export const clearFetchedStaff = () => ({
  type: CLEAR_FETCHED_STAFF,
});

export const searchStaff = (filter, selectedStaffIds) => ({
  type: SEARCH_STAFF,
  payload: { filter, selectedStaffIds },
});

export const searchStaffFailure = () => ({
  type: SEARCH_STAFF_FAILURE,
});

export const searchStaffSuccess = (fetchedStaff = []) => ({
  type: SEARCH_STAFF_SUCCESS,
  payload: { fetchedStaff },
});
